import "./PharmaceuticalCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import PharmaceuticalHero from "./sections/PharmaceuticalHero";
import Casestudytwocolumn from "./sections/Casestudytwocolumn";
import Footer from "@/reusable_sections/Footer";
export default function PharmaceuticalCaseStudyPage() {
  return <div>
      <Header />
      <PharmaceuticalHero />
      <Casestudytwocolumn />
      <Footer />
    </div>;
}